import { Key } from '@mui/icons-material';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const useRoleTableColumns = (
  editItemPermissions,
  editItem,
  apiRef,
  columnPermissions = {},
) => {
  const {
    canEdit = false,
    canViewPermissions = false,
  } = columnPermissions;

  const canViewActions = canEdit || canViewPermissions;

  const columnsData = [
    {
      field: 'name',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 250,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.name;
      },
    },

    ...(canViewActions
      ? [
          {
            field: 'actions',
            headerName: 'عملیات',
            type: 'actions',
            flex: 0.5,
            align: 'right',
            minWidth: 240,

            getActions: params => {
              if (!params.row.editable) {
                return [
                  <TableActionButtons key={10} buttons={undefined} />,
                ];
              }

              const buttons = [
                canViewPermissions
                  ? {
                      label: 'دسترسی‌ ها',
                      Icon: Key,
                      onClick: editItemPermissions(params.row),
                    }
                  : null,
                canEdit
                  ? {
                      label: 'ویرایش',
                      Icon: ModeEditOutlineIcon,
                      onClick: editItem(params.row),
                      color: 'warning',
                    }
                  : null,
              ].filter(Boolean);

              return [
                <TableActionButtons
                  key={10}
                  buttons={buttons.length ? buttons : undefined}
                />,
              ];
            },
          },
        ]
      : []),
  ];

  return [columnsData];
};

export default useRoleTableColumns;
